import { Button, Flex, Image, Link, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import unknownloader from "../assets/circle.svg";
// import iphoneModel from "../assets/TG_anniv_AR33.usdz";
import BG from "../assets/bg.png";
import Title from "../assets/title.png";
import { motion } from "framer-motion";
import AR from "../assets/TG_anniv_AR3.glb";

function Home() {

  return (
    <Flex
      // overflow={"hidden"}
      backgroundImage={BG}
      backgroundRepeat={"no-repeat"}
      bgSize={"cover"}
      height={"100vh"}
      width={"100%"}
      flexDir={"column"}
    >
      <Flex zIndex={1} position={"absolute"}>
        <Image width={"300px"} px={"20px"} pt={"50px"} src={Title}></Image>
      </Flex>
      <model-viewer
     ar-scale="auto"
        exposure="0.5"
        src={AR}
        autoplay
        animation-name="Logo_anime"
        disable-tap
        // ios-src={iphoneModel}
     
        magic-leap
        ar
        poster={unknownloader}
        ar-modes="scene-viewer webxr quick-look"
        camera-controls
        tone-mapping="neutral"
        shadow-intensity="1"
      >
        
        <div className="progress-bar hide" slot="progress-bar">
          <div className="update-bar"></div>
        </div>

        <Button
          zIndex={7}
          mt={"570px"}
          width={"100%"}
          height={"70px"}
          color={"white"}
          slot="ar-button"
          id="ar-button"
          bg="blue.500"
          _hover={{ bg: "blue.600" }}
          animation="pulse 1.5s infinite"
          css={{
            "@keyframes pulse": {
              "0%": { transform: "scale(1)" },
              "50%": { transform: "scale(1.05)" },
              "100%": { transform: "scale(1)" },
            },
          }}
        >
          View in your space [AR]
        </Button>
      </model-viewer>
    </Flex>
  );
}

export default Home;
